import { motion } from "framer-motion";
import {  FaGlobe, FaUsers} from "react-icons/fa";

const containerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.25 }
  }
};

const leftItem = {
  hidden: { opacity: 0, x: -40 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};

const rightItem = {
  hidden: { opacity: 0, x: 40 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};

export default function VisionMission() {
     const themeColor = "rgb(43 147 208)";
  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true }}
      className="grid grid-cols-1 lg:grid-cols-2 gap-8"
    >

      {/* Vision */}
  {/* Vision */}
<motion.div
  variants={leftItem}
  whileHover={{ y: -6 }}
  className="relative group"
>
  <div className="absolute -inset-1 bg-gradient-to-r from-blue-400 to-blue-600 rounded-2xl blur opacity-25 group-hover:opacity-40 transition duration-700"></div>

  <div className="relative bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition h-full">
    <div className="flex items-center mb-6">
      <div className="p-3 bg-blue-100 rounded-lg">
        <FaGlobe className="w-8 h-8" style={{ color: themeColor }} />
      </div>
      <h3 className="ml-4 text-2xl font-bold text-gray-900">
        Our Vision
      </h3>
    </div>
    <p className="text-lg text-gray-600 leading-relaxed">
      To be a catalyst in strengthening national and international cooperation for the growth and development of MSMEs.
    </p>
  </div>
</motion.div>


{/* Mission */}
<motion.div
  variants={rightItem}
  whileHover={{ y: -6 }}
  className="relative group"
>
  {/* SAME BLUE GLOW */}
  <div className="absolute -inset-1 bg-gradient-to-r from-blue-400 to-blue-600 rounded-2xl blur opacity-25 group-hover:opacity-40 transition duration-700"></div>

  <div className="relative bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition h-full">
    <div className="flex items-center mb-6">
      {/* Keep icon background blue too */}
      <div className="p-3 bg-blue-100 rounded-lg">
        <FaUsers className="w-8 h-8" style={{ color: themeColor }} />
      </div>
      <h3 className="ml-4 text-2xl font-bold text-gray-900">
        Our Mission
      </h3>
    </div>
    <p className="text-lg text-gray-600 leading-relaxed">
      To build WASME as a foremost world private and cohesive community of MSMEs that is dedicated to strengthen and foster them as prime driver of global economy.
    </p>
  </div>
</motion.div>


    </motion.div>
  );
}
